import { Injectable, signal } from '@angular/core';
import { Event, NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NavService {
  showClass: any = false;

  private updateMenu = new BehaviorSubject<any>('');
  updatedMenu = this.updateMenu.asObservable();


  public currentUrl = signal<string | undefined>(undefined);

  constructor(private router: Router) {
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        this.currentUrl.set(event.urlAfterRedirects);
      }
    });
  }


    // Change the message
  changeMenu(update: any) {
    this.updateMenu.next(update);
  }
}
